export const isValid = obj =>
  obj &&
  typeof obj === 'object' &&
  Object.prototype.hasOwnProperty.call(obj, 'id') &&
  obj.id;
